import FeedbackTour from 'src/components/FeedbackTour/FeedbackTour';
import { capitalizeFirstLetter } from 'src/utils/string';

const CardMetasPageSteps = (
  intl,
  resources,
  jaExisteFeedback,
  isLoadingFeedback
) => {
  const feature = {
    id: 8,
    descricao: 'cardMetas',
  };

  return [
    {
      selector: '.iniciando-tour',
      content: capitalizeFirstLetter(
        intl.formatMessage({ id: 'iniciandoTour' })
      ),
      position: [20, 20],
    },
    {
      selector: '.cardMeta-step1',
      content: capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'selecioneFiltrosCard' },
          {
            area: capitalizeFirstLetter(resources.area),
            colaborador: capitalizeFirstLetter(resources.colaborador),
          }
        )
      ),
    },
    {
      selector: '.cardMeta-step2',
      content: capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'informacoesCabecalho' },
          {
            area: resources.area,
            colaborador: resources.colaborador,
            score: intl.formatMessage({ id: 'score' }).toLowerCase(),
            contratometas: resources.contratometas.toLowerCase(),
          }
        )
      ),
    },
    {
      selector: '.cardMeta-step3',
      content: capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'infoExpandir' },
          {
            area: resources.area,
            colaborador: resources.colaborador,
            cardmetas: resources.cardmetas,
          }
        )
      ),
    },

    ...(jaExisteFeedback
      ? []
      : [
          {
            selector: '.dash-feedback',
            content: (
              <FeedbackTour
                feature={feature}
                intl={intl}
                isLoadingFeedback={isLoadingFeedback}
              />
            ),
            position: 'center',
          },
        ]),
  ];
};

export default CardMetasPageSteps;
